<template>
  <div id="app">
    <header>
      <span>数学长征</span>
      <div class="headerBtn" v-if="phone">
        <div  class="user">
          <img src="./assets/imgs/user.jpg" style="width: 32px;height: 32px;"/>
          <span style="font-size: 16px;padding: 0 10px;font-weight: bold;">{{phone}}</span>
        </div>
        <el-tooltip effect="light" content="系统设置" placement="bottom">
          <span class="tool"><i class="iconfont icon-xitongshezhi"></i></span>
        </el-tooltip>
        <el-tooltip effect="light" content="帮助" placement="bottom">
          <span class="tool"><i class="iconfont icon-bangzhu"></i></span>
        </el-tooltip>
        <el-tooltip effect="light" content="退出" placement="bottom">
          <span class="tool" @click="logoutReq"><i class="iconfont icon-loginout"></i></span>
        </el-tooltip>
      </div>
    </header>
    <main>
      <transition  mode="out-in"
          enter-active-class="animated fadeInLeft"
          leave-active-class="animated fadeOutRight">
        <router-view class="router"></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { deBouce } from '@/utils'
export default {
  name: 'app',
  mounted () {
    window.addEventListener('resize', () => {
      this.resizeWindow()
    })
    this.resizeWindow()
  },
  methods: {
    logoutReq () {
      this.$confirm('此操作将退出该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      }).catch(() => {
        console.log('cancel logout.')
      })
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({name: 'login'})
      }).catch(err => {
        console.log(err)
      })
    },
    resizeWindow () {
      deBouce(() => {
        let winHeight = document.body.offsetHeight
        this.$store.dispatch('SetWinHeight', winHeight)
      }, 500)
    }
  },
  computed: {
    ...mapGetters([
      'phone'
    ])
  }
}
</script>

<style>
body {
  margin: 0;
}

#app,
body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}

main {
  margin-top: 0px;
  min-height: calc(100vh - 56px);
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #1D8CE0;
  color: #ffffff;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
}

.user{
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user:hover{
  color: brown;
}

.router{
  min-height: calc(100vh - 56px);
  animation-duration: .5s;
  box-shadow: none;
}
.headerBtn{
  display: flex;
  align-items: center;
}
.tool{
  padding: 10px;
  cursor: pointer;
}
.tool:hover{
  color: brown;
}
.tool i{
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// App.vue?b8a98c0c